import * as Icons from "@phosphor-icons/react";
import { icons as iconData } from "@phosphor-icons/core";

export const icons = iconData.map((entry) => ({
  ...entry,
  Icon: Icons[entry.pascal_name],
}));
